/* eslint-disable react-hooks/exhaustive-deps */
import { TextField } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {
    createComponentValue as createComponentValueAction,
    fetchMaintenanceIssue as fetchMaintenanceIssueAction,
} from '../../../../../../../../actions/collections/maintenanceIssues';

function TableComponent({
    disabled,
    fetchMaintenanceIssue,
    id,
    issueId,
    itemId,
    rowId,
    columnId,
    value,
    createComponentValue,
}) {
    const [componentData, setComponentData] = useState(value);

    const initialRender = useRef(true);
    useEffect(() => {
        (async () => {
            if (initialRender.current) {
                initialRender.current = false;
            } else if (componentData !== null) {
                await createComponentValue({
                    body: {
                        columnComponentId: columnId,
                        rowComponentId: rowId,
                        value: componentData,
                    },
                    issueId,
                    itemId,
                });
                fetchMaintenanceIssue({ id: issueId });
            }
        })();
    }, [createComponentValue, componentData, rowId, columnId, issueId, itemId]);

    return (
        <TextField
            defaultValue={componentData}
            disabled={disabled}
            fullWidth
            id={`${id}Value`}
            name="value"
            onBlur={({ target }) => setComponentData(target.value)}
            onKeyPress={({ key, target }) => key === 'Enter' && target.blur()}
            variant="outlined"
        />
    );
}

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            createComponentValue: createComponentValueAction,
            fetchMaintenanceIssue: fetchMaintenanceIssueAction,
        },
        dispatch
    );

export default connect(null, mapDispatchToProps)(TableComponent);
